:host img {
  display: inline-block;
  vertical-align: var(--vx-icon-vertical-align, top);
  filter: invert(100%);
  max-height: unset;
  min-height: unset;
  max-width: unset;
  margin: auto;
}
:host img.reinvert {
  filter: invert(0%);
}